import { useEffect, useState } from "react"
 
import axios from "axios"
import { useReducer } from "react";
import { Box, Button, Grid, GridItem, Heading } from '@chakra-ui/react'

 
import { Spinner } from '@chakra-ui/react'
 
import { ProductReducer } from "../reducer/ProductReducer";
import ProductCardWomen from "../Components/ProductsCardWomen";

let initialState={
  products:[],
  isLoading:false,
  isErr:false
}

 

export default   function  Women(){
    const [state, dispatch] = useReducer( ProductReducer,initialState);
    const {products,isLoading,isErr}=state;
    const [sortBy, setSortBy] = useState("asc");

    const getData=async function getUser(){
      dispatch({type : "FETCH_LOADING" })
      try {
        const response=await axios.get(`https://mock-api-server-2399.onrender.com/women`)
        dispatch({type : "FETCH_SUCCESS", payload : response.data})
        // console.log(response.data)
      } catch (error) {
        console.log("error !")
        dispatch({type : "FETCH_FAILURE", payload : []})
      }
    }
 
    useEffect(()=>{
      if(sortBy==="asc"){
        const Arr = [...products].sort((a,b)=> Number(a.MRP) - Number(b.MRP) )
         dispatch({type : "FETCH_SUCCESS", payload : [...Arr] })
      }
      else if(sortBy==="desc"){
        const Arr = [...products].sort((a,b)=> Number(b.MRP) - Number(a.MRP) )
         dispatch({type : "FETCH_SUCCESS", payload :  [...Arr] })
      }
      getData();
    },[sortBy])
 

  return  isLoading  ?            
         (
          <Spinner
          marginTop="300px"
          marginLeft="100px"
          marginBottom="300px"
          thickness='4px'
          speed='0.65s'
          emptyColor='gray.200'
          color='blue.500'
          size='xl'
        />
    )
    : 
          isErr ?   <h1>Something went Wrong ! </h1> :
      (
      <div>
         <Heading mt={3} fontSize={25}>Sort By Price </Heading>
         <Box gap={5}>
          <Button   m={5} isDisabled={sortBy==="asc"} onClick={()=> setSortBy("asc")}>ASC</    Button>
          <Button   isDisabled={sortBy==="desc"} onClick={()=> setSortBy("desc")}>DESC</Button>
        </Box>
        <Grid  templateColumns="repeat(auto-fill, minmax(300px, 1fr))" gap={6}>
          {
            products?.length>0 && products.map((e)=>{
              return <GridItem key={e.id} w='100%' >
                   <ProductCardWomen
                      id={e.id}
                      category={e.category}
                      image={e.src}
                      price={e.MRP}
                      discount={e.discount}
                   />
              </GridItem>        
            })
          }
          </Grid>
          
      </div>
    )
  }
 
// "href": "https://www.limeroad.com/green-cotton-seva-chikan-p19208496?imgIdx=3&src_id=navdeskKurtas__100",
// "src": "https://img3.junaroad.com/uiproducts/19208496/zoom_0-1674239423.jpg",
// "Category": "kurta",
// "bxs1": "New",
// "discountPrice": "₹ 2249",
// "MRP": "₹2590",
// "discount": "13% off",
// "c9 href": "https://www.limeroad.com/brand/seva-chikan-74729?src_id=navdeskKurtas__100",
// "translation_missing": "Seva Chikan",
// "tdN href": "https://api.whatsapp.com/send?text=Checkout+this+amazing+product+at+Limeroad%21%20Don%27t+miss+out%21%20https://www.limeroad.com/green-cotton-seva-chikan-p19208496?imgIdx=3&src_id=navdeskKurtas__100"
 
 